module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.606b164.woff2";